exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body,button,dd,dl,fieldset,form,h1,h2,h3,input,ol,p,td,textarea,th,ul{margin:0;padding:0}html{-webkit-text-size-adjust:none;word-wrap:break-word}h1,h2,h3{font-size:100%}ol,ul{list-style:none}table{border-collapse:collapse;border-spacing:0;empty-cells:show;font-size:inherit}fieldset,img{border:0}b,cite,em,i,s{font-style:normal}button,input,select,textarea{font-size:100%}body,button,input,option,select,textarea{font-size:normal}a,input,textarea{text-decoration:none;outline:0;-webkit-tap-highlight-color:transparent}img,input,label,li{vertical-align:middle}var{font-style:normal}ins{text-decoration:none}body,html{height:100%;font-size:.2rem;font-family:Arial,Verdana,Sans-serif}.viewport{width:100%;margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/sass-loader?indentedSyntax&includePaths[]=/Users/kunkun/work/cssshow/~/compass-mixins/lib&includePaths[]=/Users/kunkun/work/cssshow/mixins/app_mixins!./sass/base.sass
// module id = 259
// module chunks = 0